import { Component, OnInit } from '@angular/core';
import { AuthService, AppInformationService, UtilityService } from './core/core.module';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { EntityManagerProvider } from './core/data/entity-manager-provider';
import { filter, map, mergeMap } from 'rxjs/operators';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { Location, registerLocaleData } from '@angular/common';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.css']
})
export class AppComponent implements OnInit {
    initVersionCheckTimeout: any;
    enviro: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private entityManagerProvider: EntityManagerProvider,
        private auth: AuthService,
        private titleService: Title,
        public appInfo: AppInformationService,
        private utility: UtilityService,
        private location: Location
    ) {}

    async ngOnInit() {
        registerLocaleData(localeEn, 'en');
        registerLocaleData(localeEs, 'es');

        document.addEventListener('initVersionCheck', async () => {
            if (!this.initVersionCheckTimeout) {
                this.versionCheck();
                this.initVersionCheckTimeout = setInterval(this.versionCheck.bind(this), 300000);
            }
        });

        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map(route => {
                    while (route.firstChild) route = route.firstChild;
                    return route;
                }),
                filter(route => route.outlet === 'primary'),
                mergeMap(route => route.data)
            )
            .subscribe(event => {
                if (location.href.indexOf('localhost') > -1 || location.href.indexOf('dev') > -1) {
                    this.enviro = 'dev';
                }
                let title = 'Brewers';
                if (event['title']) title += ' - ' + event['title'];
                this.titleService.setTitle(title);
                this.appInfo.title = event['title'];
                const initVersionCheckEvent = new CustomEvent('initVersionCheck');
                document.dispatchEvent(initVersionCheckEvent);
            });

        try {
            if (location.pathname.indexOf('/login') === -1 && this.auth.currentUser) {
                await this.entityManagerProvider.prepare();
                return
            }
        } catch (e: any) {
            console.error(e);
            // this.router.navigate(['/login']);
        }
    }

    async versionCheck() {
        const currentUser = await this.auth.currentUser;
        if (!currentUser) {
            this.appInfo.versionWarning = null;
            return;
        }
        const serviceVersion = await this.utility.getServiceVersion();
        const clientVersion = this.appInfo.clientVersion;
        if (this.appInfo.serviceVersion !== serviceVersion) this.appInfo.serviceVersion = serviceVersion;
        if (!serviceVersion || !clientVersion) this.appInfo.versionWarning = 'Unknown version information';
        else if (serviceVersion !== clientVersion) {
            this.appInfo.versionWarning = 'New Version Available - Save ALL Changes, then Refresh Browser (Crtl + F5) For Latest Update';
        } else this.appInfo.versionWarning = null;
    }
}
